import {Component, EventEmitter, Input, OnInit, Output, TemplateRef, ViewChild} from '@angular/core';
import {MatAutocomplete, MatAutocompleteSelectedEvent, MatAutocompleteTrigger, MatOption} from '@angular/material/autocomplete';
import {AsyncPipe, NgForOf} from '@angular/common';
import {Session} from '../../domain/session';
import {Carrier} from '../../domain/carrier';
import {FormControl, FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatInput} from '@angular/material/input';
import {Observable} from 'rxjs/internal/Observable';
import {startWith} from 'rxjs/internal/operators/startWith';
import {map} from 'rxjs/operators';

@Component({
    selector: 'app-carrier-search-input',
    imports: [
        MatOption,
        NgForOf,
        MatAutocomplete,
        MatAutocompleteTrigger,
        FormsModule,
        MatInput,
        ReactiveFormsModule,
        AsyncPipe
    ],
    templateUrl: './carrier-search-input.component.html',
    standalone: true,
    styleUrl: './carrier-search-input.component.css'
})
export class CarrierSearchInputComponent implements OnInit {
  formControl = new FormControl('');

  carriers: Carrier[];
  filteredCarriers: Observable<Carrier[]>;

  @Input() value: Carrier;

  @Output() carrierSelected: EventEmitter<Carrier> = new EventEmitter;

  @ViewChild("carrierInput")
  carrierInput: TemplateRef<any>

  constructor(public session: Session) {
    this.carriers = session.getCarriers();
  }

  ngOnInit(): void {
    this.filteredCarriers = this.formControl.valueChanges.pipe(
      startWith(''),
      map(value => this.filterCarriers(value || ''))
    );

    this.formControl.valueChanges.subscribe((value) => {
      if (value == null || value == '') {
        this.value = null;
        this.carrierSelected.emit(null);
      }
    })
  }

  autocompleteCarrierSelected(event: MatAutocompleteSelectedEvent) {
    this.value = this.carriers.find(c => this.getCarrierDisplayName(c) == event.option.value);

    this.formControl.setValue(this.getCarrierDisplayName(this.value));

    this.carrierSelected.emit(this.value);
  }

  private filterCarriers(filterValue: string): Carrier[] {
    if (this.value != null && filterValue.toLowerCase() == this.getCarrierDisplayName(this.value).toLowerCase()) {
      return this.carriers;
    }

    return this.carriers.filter(carrier =>
      carrier.ExternalId.toLowerCase().includes(filterValue.toLowerCase()) ||
      carrier.Name.toLowerCase().includes(filterValue.toLowerCase())
    );
  }

  protected getCarrierDisplayName(carrier: Carrier) {
    return `${carrier.Name}`;
  }
}
